/// <reference path="./../Container/Window/Window.ts" />
namespace HA.Core.HTML.Editor {

    export class Selector extends Window {

        public select(item: any): void {
            this.getItems().forEach((s: SelectorItem) => {
                if (s && s.equals(item)) {
                    s.checked();
                }
            });
        }

        public deselectAll(): void {
            this.getItems().forEach((s: SelectorItem) => {
                s.unchecked();
            });
        }

        public getSelections() {
            const data = [];
            this.getItems().forEach((s: SelectorItem) => {
                if (s && s.isChecked()) {
                    data.push(s.getValue());
                }
            });

            return data;
        }

        /**
         *
         * @returns {Map}
         */
        protected getItems() {
            return this.getList().getItems();
        }

        /**
         *
         * @returns {List}
         */
        protected getList() {
            return this.get("list");
        }

        protected initialize(data: any) {
            super.initialize(data);
            this.appendChild(this.createHead());
            this.addClass("ds");
            this.initList();
        }

        protected initList() {
            const me = this;
            const list = new List(new CFlexContainer());
            list.addClass("dl");

            const dataList = this.get("dlist");
            if (dataList) {
                dataList.forEach((data: Map<any, any>) => {
                    list.addItem(me.createItem(data));
                });
            }
            this.addToData("list", list);
            this.appendChild(list);
        }

        /**
         *
         * @param data
         * @returns {HA.Core.HTML.SelectorHead}
         */
        protected createHead(data?: any) {
            return new SelectorHead(data);
        }

        protected createItem(data: any): SelectorItem {
            if (this.has("pfunc")) {
                data.set("pfunc", this.get("pfunc").itemClick);
            }

            return new SelectorItem(data);
        }
    }
}
